package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.export

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.apaleo_properties.ListApaleoProperty
import org.hs_soft.runmynesto.domain.model.home.options.export.ApaleoSaleGroupHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.options.export.OptionCreditCardsHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.options.export.apaleo_payment_method.ApaleoPaymentMethods
import org.hs_soft.runmynesto.domain.model.home.options.export.apaleo_sub_account.ApaleoSubAccounts
import org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info.CashRegisterGlobal
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.sale_group.SaleItem
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.CustomTable
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Text


@Composable
fun Export(
    state: OptionsState,
    event:(OptionsEvent)->Unit,
    windowSizeMode: WindowSizeModeEnum
) {
    LaunchedEffect(Unit){
        event(OptionsEvent.GetApaleoProperties)
        event(OptionsEvent.GetProductSalesGroup(onSaleGroupItemClickAction = false))
        event(OptionsEvent.GetApaleoPaymentMethods)
        event(OptionsEvent.GetOptionCreditCards)
        event(OptionsEvent.GetCashRegisterGlobal)
    }

    Column(
        modifier = VerticalScrollBehavior.toModifier()
            .borderSetting()
            .fillMaxWidth()
            .fillMaxHeight()
            .borderRadius(Dimen.semiLargeRadius)
            .padding(Dimen.extraLargePadding)

    ){

        ClientSecretCodeAndID(
            cashRegisterGlobal=state.cashRegisterGlobal,
            updateCashRegisterGlobal = {title: String, value: String ->
                event(
                    OptionsEvent.UpdateCashRegisterGlobal(
                        title=title,
                        value=value,
                    )
                )
            }
        )

        SelectSalesGroupsForApaleoSubaccounts(
            hotels=state.apaleoProperties,
            apaleoSubAccounts=state.apaleoSubAccounts,
            salesGroup=state.productSalesGroup,
            selectApaleoSubAccounts={ value:String->
                event(OptionsEvent.GetApaleoSubAccounts(
                    propertyId = value
                ))
            }
        )

        UpdatingApaleoPaymentWithCashRegisterMethod(
            paymentMethods=state.apaleoPaymentMethods,
            creditCards=state.optionCreditCards?.filterNotNull(),
        )

    }


}

@Composable
fun UpdatingApaleoPaymentWithCashRegisterMethod(
    paymentMethods: List<ApaleoPaymentMethods?>?,
    creditCards: List<String?>?
) {
    val selectedPaymentMethod= remember { mutableStateOf<ApaleoPaymentMethods?>(null) }

    Column()
    {
        MediumContentTitle(
            title = Strings.current().updatingApaleoPaymentWithCashRegister,
            marginBottom = Dimen.mediumPadding,
        )

        Row(
            modifier = Modifier
        )
        {
            DropDownItem(
                modifier = Modifier
                    .margin(bottom = Dimen.extraLargePadding),
                label =Strings.current().apaleoPMSProperty ,
                options =paymentMethods?: listOf(),
                selectedItem =selectedPaymentMethod.value,
                displayText ={
                    if (it is ApaleoPaymentMethods?)
                        it.name?:""  else ""
                },
                onOptionClick ={
                   if (it is ApaleoPaymentMethods?){
                       selectedPaymentMethod.value=it
                   }
                },
            )


            val (columns, tableData) = setCreditCardsTableInfo(
                data = creditCards,
                showCheckBoxes=selectedPaymentMethod.value!=null,
            )

            CustomTable(
                height = Dimen.apaleoSalesGroupTableHeight,
                modifier = Modifier
                    .margin(
                        left = Dimen.largePadding,
                        top = Dimen.normalPadding,
                    ),
                minHeight =Dimen.apaleoSalesGroupTableHeight ,
                columns = columns,
                width = Dimen.apaleoConfigurationTableWidth,
                data = tableData,
                showRefreshButton = false,

            )

        }
    }

}


@Composable
fun SelectSalesGroupsForApaleoSubaccounts(
    hotels: List<ListApaleoProperty?>?,
    salesGroup: List<SaleItem>?,
    apaleoSubAccounts: List<ApaleoSubAccounts?>?,
    selectApaleoSubAccounts:(String)->Unit,
)
{
    val selectedHotel= remember { mutableStateOf<ListApaleoProperty?>(null) }
    val selectedApaleoSubAccount= remember { mutableStateOf<ApaleoSubAccounts?>(null) }

    Column()
    {

        MediumContentTitle(
            title = Strings.current().selectSalesGroupsForApaleoSubaccounts,
            marginBottom = Dimen.mediumPadding,
        )


        Row()
        {
            Column {
                DropDownItem(
                    modifier = Modifier
                        .margin(bottom = Dimen.extraLargePadding),
                    label =Strings.current().apaleoPMSProperty ,
                    options =hotels?: listOf(),
                    selectedItem =selectedHotel.value,
                    displayText ={
                        if (it is ListApaleoProperty?){
                             it.name?:""
                        }else ""
                    },
                    onOptionClick ={
                        if (it is ListApaleoProperty?){
                            selectApaleoSubAccounts(it.id?:"")
                            selectedHotel.value=it
                        }
                    },
                )
                if (selectedHotel.value!=null){
                    DropDownItem(
                        modifier = Modifier
                            .margin(bottom = Dimen.extraLargePadding),
                        label =Strings.current().apaleoPMSSubAccounts ,
                        options =apaleoSubAccounts?: listOf(),
                        selectedItem =selectedApaleoSubAccount.value,
                        displayText ={
                            if (it is ApaleoSubAccounts?){
                                it.name?:""
                            }  else ""
                        },
                        onOptionClick ={
                            if (it is ApaleoSubAccounts?){
                                selectedApaleoSubAccount.value=it
//                                selectApaleoSubAccounts(it.id?:"")
                            }
                        },
                    )
                }
            }


            val (columns, tableData) = setSaleGroupTableInfo(
                data =salesGroup,
                showCheckBoxes=selectedApaleoSubAccount.value!=null,
            )
            CustomTable(
                height =Dimen.apaleoSalesGroupTableHeight ,
                modifier = Modifier
                    .margin(
                        left = Dimen.largePadding,
                        top = Dimen.normalPadding,
                    ) ,
                columns = columns,
                width = Dimen.apaleoConfigurationTableWidth,
                data = tableData,
                showRefreshButton = false,
            )

        }
    }



}

private fun setSaleGroupTableInfo(
    data: List<SaleItem>?,
    showCheckBoxes: Boolean
): Pair<List<TableColumn>, List<Map<String, Any?>>?> {

    val columns = ApaleoSaleGroupHeadersEnum.entries.map { header ->
        TableColumn(
            header = header.title,
            key = header.key,
            isNumeric = header.isNumeric,
            sortFunction = when {
                header.isNumeric -> { row ->
                    (row[header.key]?.toString() ?: "0").replace(",", "")
                        .toDoubleOrNull() ?: 0.0
                }
                else -> null
            },
            customContent = if (header.key == ApaleoSaleGroupHeadersEnum.CHECK.key) {
                { row ->
                    {
                        if (showCheckBoxes){
                            val isChecked = remember { mutableStateOf(false) }
                            CheckboxComponent(
                                checkStatus = isChecked.value,
                                title = "",
                                onChecked = { isChecked.value = true },
                                onUnChecked = { isChecked.value = false }
                            )
                        }

                    }
                }
            } else null
        )
    }

    val tableData = data?.map { item ->
        ApaleoSaleGroupHeadersEnum.entries.associate { header ->
            when(header.key){
                ApiUtils.Field.number -> header.key to item.acountNum
                ApiUtils.Field.name -> header.key to item.name
                "checkBox" -> header.key to false
                else -> header.key to null
            }
        }
    }

    return Pair(columns, tableData)
}


private fun setCreditCardsTableInfo(
    data: List<String?>?,
    showCheckBoxes: Boolean
): Pair<List<TableColumn>, List<Map<String, Any?>>?> {

    val columns = OptionCreditCardsHeadersEnum.entries.map { header ->
        TableColumn(
            header = header.title,
            key = header.key,
            isNumeric = header.isNumeric,
            sortFunction = when {
                header.isNumeric -> { row ->
                    (row[header.key]?.toString() ?: "0").replace(",", "")
                        .toDoubleOrNull() ?: 0.0
                }
                else -> null
            },
            customContent = if (header.key == "checkBox") {
                { row ->
                    {
                        if (showCheckBoxes){
                            val isChecked = remember { mutableStateOf(false) }
                            CheckboxComponent(
                                checkStatus = isChecked.value,
                                title = "",
                                onChecked = { isChecked.value = true },
                                onUnChecked = { isChecked.value = false }
                            )
                        }

                    }
                }
            } else null
        )
    }

    val tableData = data?.map { item ->
        OptionCreditCardsHeadersEnum.entries.associate { header ->
            when(header.key){
                ApiUtils.Field.name -> header.key to item
                "checkBox" -> header.key to false
                else -> header.key to null
            }
        }
    }

    return Pair(columns, tableData)
}

@Composable
fun ClientSecretCodeAndID(
    cashRegisterGlobal: CashRegisterGlobal?,
    updateCashRegisterGlobal: (String, String) -> Unit
)
{

    Column()
    {
        CustomEditText(
            modifier = Modifier ,
            width = Dimen.mediumEditTextWidth,
            label = Strings.current().clientId,
            value =cashRegisterGlobal?.apaleaoClientId?:"",
            onFocusIn = { },
            onInputChange = { newValue, validation ->

            },
            onFocusOut = {
                updateCashRegisterGlobal(
                    ApiUtils.Field.apaleaoClientId,it
                )
            },
        )

        CustomEditText(
            modifier = Modifier ,
            width = Dimen.mediumEditTextWidth,
            label = Strings.current().clientSecret,
            value =cashRegisterGlobal?.apaleaoClientSecret?.toString()?:"",
            onFocusIn = { },
            inputType = InputType.Password,
            onInputChange = { newValue, validation ->

            },
            onFocusOut = {
                updateCashRegisterGlobal(
                    ApiUtils.Field.apaleaoClientSecret,it
                )
            },
        )

    }


}

